var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndexDiagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15.104mm",
    height: "48.203mm",
    viewBox: "0 0 15.104 48.203",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43.699 -118.33)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m44.659 142.42c6.5875 0 6.5875 23.146 13.184 23.146",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".71994px",
      stroke: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m44.659 142.42c6.5875 0 6.5875-23.137 13.184-23.137",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".71994px",
      stroke: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m44.659 142.42c6.5875 0 6.5875-7.7124 13.184-7.7124",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".71994px",
      stroke: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m44.659 142.42c6.5875 0 6.5875 7.7214 13.184 7.7214",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".71994px",
      stroke: "#8c8c8c"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndexDiagram);
export default __webpack_public_path__ + "static/media/index_diagram.66d833e1.svg";
export { ForwardRef as ReactComponent };